export const getLEDGuardKey = (devicestring: string) =>
  `ledTurnedOn_${devicestring}`;

export const getLEDCacheKey = (devicestring: string) =>
  `ledSensorToggle_${devicestring}`;

export interface LEDCache {
  state: boolean;
  timestamp: number;
  devicestring: string;
  humanReadable: Date;
}

const STALE_TTL_MS = 86_400_000; // 24 hours
const LED_PREFIXES = ["ledTurnedOn_", "ledSensorToggle_"];

const isLEDKey = (key: string) => 
  LED_PREFIXES.some((prefix) => key.startsWith(prefix));

const isStaleTimestamp = (raw: string): boolean => {
  const { timestamp } = JSON.parse(raw);
  return typeof timestamp === "number" && Date.now() - timestamp > STALE_TTL_MS;
};

export const cleanStaleLEDKeys = () => {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (!key || !isLEDKey(key)) continue;

    try {
      const raw = localStorage.getItem(key);
      if (raw && isStaleTimestamp(raw)) {
        localStorage.removeItem(key);
      }
    } catch {
      localStorage.removeItem(key); // If the data cannot be parsed (in the try block), then delete the key anyway
    }
  }
};

export const setCachedLEDState = (devicestring: string, state: boolean) => {
  const cache: LEDCache = {
    state,
    timestamp: Date.now(),
    devicestring,
    humanReadable: new Date(),
  };
  localStorage.setItem(getLEDCacheKey(devicestring), JSON.stringify(cache));
};
